<div class="parallex">
	<div class="legacy-section help-section">
	<div class="container container-mobile">
		<h2>{{ title }}</h2>

		<div class="legacy-grid">
			@for (item of items; track item.title) {
				<div class="legacy-card" [class.second]="item.reverse">
					@if (item.reverse) {
						<div class="legacy-content">
							<h3>{{ item.title }}</h3>
							<p>{{ item.description }}</p>
						</div>
						<img [src]="item.imageSrc" [alt]="item.imageAlt" />
					} @else {
						<img [src]="item.imageSrc" [alt]="item.imageAlt" />
						<div class="legacy-content">
							<h3>{{ item.title }}</h3>
							<p>{{ item.description }}</p>
						</div>
					}
				</div>
			}
		</div>

		@if (cta) {
			<div class="will-cta-button">
				<button
					type="button"
					class="btn btn-primary btn-block action-btn"
					(click)="onCtaClick()">
					{{ cta.title }}
				</button>
			</div>
		}
	</div>
</div>
</div>
